import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import Icon from '@components/Icon'

const ProgressBar = (props) => {
    const { questionNum, atQuestion, correctedAnswers } = props
    const progress = []

    for (let i = 0; i < questionNum; i++) {
        const hasCorrectedAnswer = correctedAnswers.length > i
        const answerIsCorrect = correctedAnswers[i]
        const outerClasses = classNames(
            'h-[26px] w-[26px] rounded-full mr-1 relative border',
            {
                'border-transparent': i !== atQuestion,
                'border-black': i === atQuestion,
            }
        )

        const innerClasses = classNames('h-5 w-5 mt-0.5 ml-0.5 rounded-full', {
            'bg-quizGrey': i >= atQuestion && answerIsCorrect === undefined,
            'bg-black': i < atQuestion && !hasCorrectedAnswer,
            'bg-alertGreen': hasCorrectedAnswer && answerIsCorrect,
            'bg-alertRed': hasCorrectedAnswer && !answerIsCorrect,
        })

        progress.push(
            <div key={i} className={outerClasses}>
                <div className={innerClasses}>
                    {hasCorrectedAnswer && !answerIsCorrect && (
                        <div
                            className={
                                'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white'
                            }
                        >
                            <Icon icon={'CloseSmall'} />
                        </div>
                    )}
                </div>
            </div>
        )
    }

    return <div className={'flex flex-wrap'}>{progress}</div>
}

ProgressBar.propTypes = {
    questionNum: PropTypes.number,
    atQuestion: PropTypes.number,
    correctedAnswers: PropTypes.array,
}

export default ProgressBar
